import React from 'react'
import { Tooltip } from '@mui/material'
import { CalendarBlank, Stack, CurrencyDollar, MapPin } from '@phosphor-icons/react'
import { formatMoney } from '../../helpers/utils'

const GEOFENCE_STATUS = {
  NO_CLIENT: 'N/A',
  INSIDE: 'Sí',
  OUTSIDE: 'No',
  NOT_EVALUATED: 'Sin evaluar'
}

export default function SalesRoutePoint({ point, number, color, offset, selected, onSelect }) {
  const activity = point.activity
  const date = new Date(activity.created_date)
  const dateTime = Number.isFinite(date.getTime())
    ? date.toLocaleString(undefined, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      })
    : '—'
  const geofence = !point.client
    ? GEOFENCE_STATUS.NO_CLIENT
    : [true, 1].includes(activity.effective_location)
      ? GEOFENCE_STATUS.INSIDE
      : [false, 0].includes(activity.effective_location)
        ? GEOFENCE_STATUS.OUTSIDE
        : GEOFENCE_STATUS.NOT_EVALUATED
  return (
    <Tooltip
      arrow
      describeChild
      placement="top"
      enterDelay={100}
      slotProps={{
        popper: { sx: { zIndex: 2300 } },
        tooltip: { className: 'route-activity-tooltip' },
        arrow: { sx: { color: '#fff' } }
      }}
      title={
        <div className="route-point-card" style={{ '--point-color': color }}>
          <header className="route-point-card__header">
            <div className="route-point-card__number" aria-hidden="true">
              {number}
            </div>
            <div>
              <span className="route-point-card__eyebrow">Cliente: </span>
              <strong>{activity.client_name || 'Cliente sin nombre'}</strong>
            </div>
          </header>
          <div className="route-point-card__row">
            <CalendarBlank size={18} aria-hidden="true" />
            <div>
              <span>Fecha y hora: </span>
              <b>{dateTime}</b>
            </div>
          </div>
          <div className="route-point-card__row">
            <Stack size={18} aria-hidden="true" />
            <div>
              <span>Tipo de actividad: </span>
              <b>
                {String(activity.activity_name).toLowerCase() === 'survey'
                  ? 'Encuesta'
                  : activity.activity_name || '—'}
              </b>
            </div>
          </div>
          {activity.total != null && (
            <div className="route-point-card__row">
              <CurrencyDollar size={18} aria-hidden="true" />
              <div>
                <span>Monto: </span>
                <b>{formatMoney(activity.total)}</b>
              </div>
            </div>
          )}
          <div
            className={`route-point-card__status route-point-card__status--${
              geofence === GEOFENCE_STATUS.INSIDE
                ? 'inside'
                : geofence === GEOFENCE_STATUS.OUTSIDE
                  ? 'outside'
                  : 'unknown'
            }`}
          >
            <MapPin size={16} weight="fill" aria-hidden="true" />
            Dentro de geocerca: {geofence}
          </div>
        </div>
      }
    >
      <button
        type="button"
        className={`route-pin ${selected ? 'route-pin--selected' : ''}`}
        style={{ '--point-color': color, marginLeft: offset.x, marginTop: offset.y }}
        aria-label={`Actividad ${point.order + 1}: ${activity.client_name || 'Cliente'}`}
        aria-pressed={selected}
        onClick={onSelect}
      >
        <span className="route-pin__halo" aria-hidden="true" />
        <span className="route-pin__body" aria-hidden="true">
          <span>{number}</span>
        </span>
      </button>
    </Tooltip>
  )
}
